var map = {
	"./legals/about-us.md": [
		2088,
		[
			2088
		]
	],
	"./legals/contact-us.md": [
		6087,
		[
			6087
		]
	],
	"./legals/disclaimer.md": [
		5615,
		[
			5615
		]
	],
	"./legals/faq.md": [
		7722,
		[
			7722
		]
	],
	"./legals/privacy.md": [
		8750,
		[
			8750
		]
	],
	"./legals/terms.md": [
		3701,
		[
			3701
		]
	],
	"./product/api-reference.md": [
		8147,
		[
			8147
		]
	],
	"./product/direct-storage.md": [
		2198,
		[
			2198
		]
	],
	"./product/introduction.md": [
		7939,
		[
			7939
		]
	],
	"./product/mtproto.md": [
		4110,
		[
			4110
		]
	],
	"./product/quickstart.md": [
		6134,
		[
			6134
		]
	],
	"./product/system-design.md": [
		3485,
		[
			3485
		]
	],
	"./product/telegram-credentials.md": [
		3507,
		[
			3507
		]
	],
	"./product/version-history-desktop.md": [
		5983,
		[
			5983
		]
	],
	"./product/version-history-mobile.md": [
		4797,
		[
			4797
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2673;
module.exports = webpackAsyncContext;